import { ClickExpandTextModal } from "./ClickExpandTextModal";

export default ClickExpandTextModal;
